export default function Card({ title, description, children, className = '', headerAction }) {
  return (
    <div className={'rounded-lg border bg-white shadow-sm ' + className}>
      {(title || description || headerAction) && (
        <div className="flex items-center justify-between border-b px-6 py-4">
          <div>
            {title && <h3 className="text-lg font-semibold">{title}</h3>}
            {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      )}
      <div className="p-6">
        {children}
      </div>
    </div>
  )
}